// assets
import { IconUsers  } from '@tabler/icons';


// constant
const icons = {
    IconUsers 
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const memberManagement = {
    id: 'memberManagement',
    type: 'group',
    children: [
        {
            id: 'memberManagement',
            title: 'Member Management',
            type: 'collapse',
            icon: icons.IconUsers ,

            children: [
                {
                    id: 'list',
                    title: 'List',
                    type: 'item',
                    url: '/member-management/list',
                    breadcrumbs: true
                },
                // {
                //     id: 'createUser',
                //     title: 'Create User',
                //     type: 'item',
                //     url: '/member-management/createUser',
                //     breadcrumbs: true
                // },
                {
                    id: 'pointAjustment',
                    title: 'Point Adjustment',
                    type: 'item',
                    url: '/member-management/pointAdjustment',
                    breadcrumbs: true
                },
                {
                    id: 'withdrawRequests',
                    title: 'Withdraw Requests',
                    type: 'item',
                    url: '/member-management/withdrawRequests',
                    breadcrumbs: true
                },
                // {
                //     id: 'memberInfo',
                //     title: 'Member Info',
                //     type: 'item',
                //     url: '/member-management/memberInfo',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'subAccounts',
                //     title: 'Sub Accounts',
                //     type: 'item',
                //     url: '/member-management/subAccounts',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'createSubAccount',
                //     title: 'Create Sub Account',
                //     type: 'item',
                //     url: '/member-management/createSubAccount',
                //     breadcrumbs: true
                // }
            ]
        }
    ]
};

export default memberManagement;
